import { render, staticRenderFns } from "./tablemanagement.vue?vue&type=template&id=052fcd44&scoped=true&"
import script from "./tablemanagement.vue?vue&type=script&lang=js&"
export * from "./tablemanagement.vue?vue&type=script&lang=js&"
import style0 from "./tablemanagement.vue?vue&type=style&index=0&id=052fcd44&scoped=true&lang=css&"
import style1 from "./tablemanagement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052fcd44",
  null
  
)

export default component.exports